var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_977_4642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1587 6.66667L10.0003 8.82501L7.84199 6.66667L6.66699 7.84167L8.82533 10L6.66699 12.1583L7.84199 13.3333L10.0003 11.175L12.1587 13.3333L13.3337 12.1583L11.1753 10L13.3337 7.84167L12.1587 6.66667ZM10.0003 1.66667C5.39199 1.66667 1.66699 5.39167 1.66699 10C1.66699 14.6083 5.39199 18.3333 10.0003 18.3333C14.6087 18.3333 18.3337 14.6083 18.3337 10C18.3337 5.39167 14.6087 1.66667 10.0003 1.66667ZM10.0003 16.6667C6.32533 16.6667 3.33366 13.675 3.33366 10C3.33366 6.32501 6.32533 3.33334 10.0003 3.33334C13.6753 3.33334 16.667 6.32501 16.667 10C16.667 13.675 13.6753 16.6667 10.0003 16.6667Z",
    fill: "#3C3C3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_977_4642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.43ae602815cbbdd67d454c6eaf0823a6.svg";
export { ForwardRef as ReactComponent };